import DOMPurify from 'dompurify';
import Alert, { type AlertColor, type AlertProps } from '@mui/material/Alert';
import { Typography } from '@mui/material';
import { type ReactNode } from 'react';
import { type SvgIconComponent } from '@mui/icons-material';

const getIcon = (Icon?: SvgIconComponent | false) => {
  if (Icon === false) {
    return false;
  }

  if (Icon) {
    return <Icon />;
  }
};

type InfoBannerPropTypes = { Icon?: SvgIconComponent | false; sx?: AlertProps['sx'] } & (
  | { text: string; children?: never; severity?: AlertColor }
  | { text?: never; children: ReactNode; severity?: AlertColor }
);

const InfoBanner = ({ text, children, Icon, severity, sx }: InfoBannerPropTypes) => {
  return (
    <Alert severity={severity ?? 'info'} icon={getIcon(Icon)} sx={sx}>
      {text && (
        <Typography
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(text)
          }}
        />
      )}
      {children && children}
    </Alert>
  );
};

export default InfoBanner;
